
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Logo: React.FC = () => (
  <Link to="/" className="flex items-center group">
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="flex items-center"
    >
      <img 
        src="/lovable-uploads/9c04ed46-f154-45c9-97e2-769141c63229.png" 
        alt="TeenVisor Logo" 
        className="h-8 w-8 rounded-md transition-transform duration-300 group-hover:rotate-6"
      />
      <span className="ml-2 text-xl font-poppins font-bold text-brand-orange transition-colors duration-300 group-hover:text-primary">TeenVisor</span>
    </motion.div>
  </Link>
);

export default Logo;
